import React from 'react';
import Button from '@tencent/dui/lib/components/Button';
import Select from '@tencent/dui/lib/components/Select';
import Radio from '@tencent/dui/lib/components/Radio';

import LinkMenuItem from './link-menu-item';
import Style from './index.less';
import { isCorrectUrl, isCorrectEmail } from '@src/utils/verify-link';
import { transMailStr2Obj } from '@src/slide/domain/ui-model/element-modeles/property/link/ui-sdk-transform';
import i18n from '@i18next/i18n';
import { EMAIL_PREFIX } from '@src/slide/domain/ui-model/element-modeles/property/link/constant/prefix';
import { getSlideTarget, getSlideUniqueIDBySelectedPPTTarget } from '@src/slide/domain/ui-model/element-modeles/property/link/utils/jump-to-slide-by-id';

const linkType = [
    {
        label: i18n.t('网页'),
        value: 'url',
    },
    {
        label: i18n.t('幻灯片'),
        value: 'ppt',
    },
    {
        label: i18n.t('电子邮件'),
        value: 'email',
    },
];

const pptActions = [
    {
        label: i18n.t('下一张幻灯片'),
        value: 'ppaction://hlinkshowjump?jump=nextslide',
    },
    {
        label: i18n.t('上一张幻灯片'),
        value: 'ppaction://hlinkshowjump?jump=previousslide',
    },
    {
        label: i18n.t('第一张幻灯片'),
        value: 'ppaction://hlinkshowjump?jump=firstslide',
    },
    {
        label: i18n.t('最后一张幻灯片'),
        value: 'ppaction://hlinkshowjump?jump=lastslide',
    },
    {
        label: i18n.t('幻灯片'),
        value: 'ppaction://hlinksldjump',
    },
];

interface LinkEditMenuProps {
    data?: any;
    handleLinkEdit: (data: any) => void;
    hide: () => void;
    handleDropDsiable?: (visible: boolean) => void;
    anchorRect: DOMRect;
    isTextLink?: boolean;
    uiDataService: any;
    getInnerLinkInfo: (slideJump: any) => string;
}

interface LinkEditMenuState {
    selectedLinkType: string;
    selectedPPTAction: string;
    selectedPPTTarget: string;
    totalPPTPage: number;
    isUrlWarning: boolean;
    isEmailWarning: boolean;
    urlLinkInfo: string;
    emailAddrInfo: string;
    emailSubInfo: string;
    linkTextContent: string;
    tipContent: string;
    listHeight: number;
    trianglePos: string;
    triangleLeft: number;
    itemsHeight: number | string;
}
/**
 * 插入链接的编辑菜单。
 */
export default class LinkEditMenu extends React.Component<LinkEditMenuProps, LinkEditMenuState> {
    private listRef: React.RefObject<HTMLDivElement> | null = null;
    private editRef: React.RefObject<HTMLDivElement> | null = null;
    private linkRef: React.RefObject<LinkMenuItem> | null = null;
    private addrRef: React.RefObject<LinkMenuItem> | null = null;

    public constructor(props: LinkEditMenuProps) {
        super(props);
        const initialState = this.initializeData();
        this.state = {
            selectedLinkType: 'url',
            selectedPPTAction: pptActions[0].value,
            selectedPPTTarget: '1',
            totalPPTPage: 1,
            isUrlWarning: false,
            isEmailWarning: false,
            urlLinkInfo: '',
            emailAddrInfo: '',
            emailSubInfo: '',
            linkTextContent: '',
            tipContent: '',
            listHeight: 0,
            trianglePos: 'top',
            triangleLeft: 180,
            itemsHeight: 0,
            ...initialState,
        };
        this.listRef = React.createRef();
        this.editRef = React.createRef();
        this.linkRef = React.createRef();
        this.addrRef = React.createRef();
        this.getPosition();
    }

    public componentDidMount() {
        setTimeout(() => {
            this.adjustHeight(this.state.selectedLinkType);
            this.handleFocus();
        }, 100);
    }

    public componentDidUpdate() {
        this.getListHeight();
    }

    public render() {
        const widthStyle = {
            width: '284px',
            height: '32px',
            borderRadius: 4,
        };
        const btnStyle = {
            height: '28px',
            width: '72px',
            marginLeft: '16px',
            borderRadius: 2,
        };
        const {
            selectedLinkType,
            linkTextContent,
            tipContent,
            trianglePos,
            triangleLeft,
        } = this.state;
        let { itemsHeight } = this.state;
        const isTextLink = typeof (this.props.isTextLink) === 'undefined' ? true : this.props.isTextLink;
        itemsHeight = itemsHeight === 0 ? 'auto' : itemsHeight;
        return (
            <div className={`${Style['link-menu-wrapper']} ${Style[trianglePos]}`} ref={this.editRef}>
                <div className={`${Style['link-menu-triangle']} ${Style[trianglePos]}`} style={{ left: triangleLeft }}></div>
                <div className={Style['link-menu-content']}>
                    <div className={`${Style['link-menu-items']} global-scroll`} style={{ height: itemsHeight }}>
                        <div style={{ display: isTextLink ? 'flex' : 'none' }}>
                            <LinkMenuItem
                                itemName={i18n.t('显示文本')}
                                itemPlaceholder={i18n.t('请输入显示文本')}
                                inputTextInfo={linkTextContent}
                                handleInputChange={this.handleTextChange}
                            />
                        </div>
                        <div className={Style['link-menu-item']}>
                            <label className={Style['link-menu-item-label']}>{i18n.t('链接至')}</label>
                            <Select
                                style={widthStyle}
                                defaultValue={selectedLinkType}
                                value={selectedLinkType}
                                onChange={this.handleSelectTypeChange}
                                onVisibleChange={this.handlePageVisibleChange}
                            >
                                {
                                    linkType.map(item => <Select.Option value={item.value} key={`${item.value}-${item.label}`}>{item.label}</Select.Option>)
                                }
                            </Select>
                        </div>
                        {
                            this.renderLinkItem()
                        }
                        <LinkMenuItem
                            itemName={i18n.t('屏幕提示')}
                            itemPlaceholder={i18n.t('播放时鼠标停留显示')}
                            inputTextInfo={tipContent}
                            handleInputChange={this.handleTipContentChange}
                        />
                    </div>
                    <div className={Style['link-menu-btns']}>
                        <Button style={btnStyle} onClick={this.handleCancel}>{i18n.t('取消')}</Button>
                        <Button type="primary" style={btnStyle} onClick={this.handleSubmit}>{i18n.t('确定')}</Button>
                    </div>
                </div>
            </div>
        );
    }

    private initializeData = () => {
        const { data } = this.props;
        if (!data) return;
        const initialState: Partial<LinkEditMenuState> = {};
        if (data.url) {
            initialState.selectedLinkType = 'url';
            initialState.urlLinkInfo = data.url;
        } else if (data.slideJump) {
            this.initializeSlideJumpCase(data, initialState);
        } else if (data.mail) {
            this.initializeMailCase(data, initialState);
        } else if (data.text) {
            this.initializeTextCase(data, initialState);
        }
        initialState.linkTextContent = data.text || '';
        initialState.tipContent = data.tooltip || '';
        initialState.totalPPTPage = this.getSlideList()?.length || 0;
        return initialState;
    };

    private initializeSlideJumpCase(data, initialState: Partial<LinkEditMenuState>) {
        initialState.selectedLinkType = 'ppt';
        initialState.selectedPPTAction = (data.slideJump.action !== 'ppaction://noaction') ? data.slideJump.action : pptActions[0].value;
        if (data.slideJump.target) {
            const target = getSlideTarget(data.slideJump.target, this.getSlideList());
            initialState.selectedPPTTarget = target;
        }
    }

    private initializeMailCase(data, initialState: Partial<LinkEditMenuState>) {
        initialState.selectedLinkType = 'email';
        initialState.emailAddrInfo = data.mail.address || '';
        initialState.emailSubInfo = data.mail.subject || '';
    }

    private initializeTextCase(data, initialState: Partial<LinkEditMenuState>) {
        const hasEmailPrefix = data.text.indexOf(EMAIL_PREFIX) === 0;
        if (isCorrectUrl(data.text) && !hasEmailPrefix) {
            initialState.selectedLinkType = 'url';
            initialState.urlLinkInfo = data.text;
        } else if (hasEmailPrefix) {
            const mail = transMailStr2Obj(data.text);
            initialState.selectedLinkType = 'email';
            initialState.emailAddrInfo = mail.address;
            initialState.emailSubInfo = mail.subject;
        }
    }

    private handleFocus = () => {
        const {
            selectedLinkType,
            urlLinkInfo,
            emailAddrInfo,
        } = this.state;
        if (selectedLinkType === 'url' && !urlLinkInfo) {
            this.linkRef?.current?.focusInput();
        } else if (selectedLinkType === 'email' && !emailAddrInfo) {
            this.addrRef?.current?.focusInput();
        }
    };

    private handleSelectTypeChange = (value) => {
        if (this.state.selectedLinkType === value) {
            this.handleFocus();
            return;
        }
        this.setState({
            selectedLinkType: value,
        }, () => {
            this.handleFocus();
            this.adjustHeight(value);
        });
    };

    private handleSelectPPTChange = (value) => {
        this.setState({
            selectedPPTAction: value,
        });
    };

    private handleSelectTargetChange = (value) => {
        this.setState({
            selectedPPTTarget: value,
        });
    };

    private handlePageVisibleChange = (visible) => {
        if (this.props.handleDropDsiable) {
            setTimeout(() => {
                this.props.handleDropDsiable?.(visible); // 可以阻止dropDown关闭
            }, visible ? 0 : 50);
        }
    };

    private handleLinkChange = (value) => {
        this.setState({
            isUrlWarning: false,
            isEmailWarning: false,
        });
        if (this.state.selectedLinkType === 'url') {
            this.setState({
                urlLinkInfo: value,
            });
        } else {
            this.setState({
                emailAddrInfo: value,
            });
        }
    };

    private handleTextChange = (value) => {
        this.setState({
            linkTextContent: value,
        });
    };

    private handleSubjectChange = (value) => {
        this.setState({
            emailSubInfo: value,
        });
    };

    private handleTipContentChange = (value) => {
        if (value.length > 255) {
            return;
        }
        this.setState({
            tipContent: value,
        });
    };

    private handleBlur = () => {
        const {
            selectedLinkType,
            urlLinkInfo,
            emailAddrInfo,
        } = this.state;

        if (selectedLinkType === 'url') {
            if (urlLinkInfo && !isCorrectUrl(urlLinkInfo)) {
                this.setState({
                    isUrlWarning: true,
                });
            }
        } else if (selectedLinkType === 'email') {
            if (emailAddrInfo && !isCorrectEmail(emailAddrInfo)) {
                this.setState({
                    isEmailWarning: true,
                });
            }
        }
    };

    private handleSubmit = () => {
        const data: any = {};

        const {
            selectedLinkType,
            urlLinkInfo,
            emailAddrInfo,
            emailSubInfo,
            linkTextContent,
            selectedPPTAction,
            selectedPPTTarget,
            tipContent,
        } = this.state;

        if (selectedLinkType === 'url') {
            if (!isCorrectUrl(urlLinkInfo)) {
                this.setState({
                    isUrlWarning: true,
                });
                return;
            }
            data.url = urlLinkInfo;
            data.text = linkTextContent || urlLinkInfo;
        } else if (selectedLinkType === 'email') {
            if (!isCorrectEmail(emailAddrInfo)) {
                this.setState({
                    isEmailWarning: true,
                });
                return;
            }
            data.mail = {
                address: emailAddrInfo,
                subject: emailSubInfo,
            };
            data.text = linkTextContent || emailAddrInfo;
        } else {
            if (selectedPPTAction === 'ppaction://noaction') {
                return;
            }
            this.handleSubmitWithPPTAction(data, selectedPPTAction, selectedPPTTarget, linkTextContent);
        }
        data.tooltip = tipContent || '';
        this.props.handleLinkEdit(data);
    };

    private handleSubmitWithPPTAction(data, selectedPPTAction, selectedPPTTarget, linkTextContent) {
        data.slideJump = {
            action: selectedPPTAction,
        };
        if (selectedPPTAction === pptActions[4].value) {
            data.slideJump.target = getSlideUniqueIDBySelectedPPTTarget(Number(selectedPPTTarget), this.getSlideList());
        } else {
            data.slideJump.target = '';
        }
        data.text = linkTextContent || this.props.getInnerLinkInfo(data.slideJump);
    }

    private handleCancel = () => {
        this.props.hide();
    };

    private adjustHeight = (type) => {
        const isTextLink = typeof (this.props.isTextLink) === 'undefined' ? true : this.props.isTextLink;
        const { itemsHeight } = this.state;
        if (this.editRef?.current) {
            const rect = this.editRef.current.getBoundingClientRect();
            const vh = document.body.clientHeight;
            let height = 0;
            if (rect.top < 10) {
                height = rect.bottom - 114;
            } else if (rect.bottom > vh - 10) {
                height = vh - rect.top - 114;
            } else if (type === 'url') {
                height = this.adjustUrlCase(isTextLink, rect, itemsHeight);
            } else if (type === 'ppt') {
                height = this.adjustPPTCase(isTextLink, rect, itemsHeight);
            } else if (type === 'email') {
                height = this.adjustMailCase(isTextLink, rect, itemsHeight);
            }
            this.setState({
                itemsHeight: height,
            });
        }
    };

    private adjustUrlCase(isTextLink, rect, itemsHeight) {
        let height;
        if (isTextLink) {
            height = rect.height < 310 ? itemsHeight : 0;
        } else {
            height = rect.height < 252 ? itemsHeight : 0;
        }
        return height;
    }

    private adjustPPTCase(isTextLink, rect, itemsHeight) {
        let height;
        if (isTextLink) {
            height = rect.height < 398 ? itemsHeight : 0;
        } else {
            height = rect.height < 340 ? itemsHeight : 0;
        }
        return height;
    }

    private adjustMailCase(isTextLink, rect, itemsHeight) {
        let height;
        if (isTextLink) {
            height = rect.height < 368 ? itemsHeight : 0;
        } else {
            height = rect.height < 310 ? itemsHeight : 0;
        }
        return height;
    }

    private getPosition = () => {
        const {
            anchorRect,
        } = this.props;
        setTimeout(() => {
            if (this.editRef?.current) {
                const rect = this.editRef.current.getBoundingClientRect();
                if (rect.bottom <= anchorRect.y) {
                    this.setState({
                        trianglePos: 'bottom',
                    });
                }
                const left = (anchorRect.x + Math.floor(anchorRect.width / 2)) - rect.left;
                this.setState({
                    triangleLeft: left,
                });
            }
        }, 0);
    };

    private getSlideList() {
        return this.props.uiDataService.slideModelList;
    }

    private getListHeight = () => {
        setTimeout(() => {
            if (this.listRef?.current) {
                const maxHeight = 186;
                let listHeight = (this.state.totalPPTPage * 32) + 18;
                const rect = this.listRef.current.getBoundingClientRect();
                const vh = document.body.clientHeight;
                let height = vh - rect.bottom - 46;
                if (height > maxHeight) {
                    height = maxHeight;
                }
                if (listHeight > height) {
                    listHeight = height;
                }
                this.setState({
                    listHeight,
                });
            }
        }, 50);
    };

    private renderLinkItem() {
        const {
            selectedLinkType,
            selectedPPTAction,
            selectedPPTTarget,
            isUrlWarning,
            isEmailWarning,
            urlLinkInfo,
            emailAddrInfo,
            listHeight,
            emailSubInfo,
        } = this.state;

        const pages: string[] = [];
        for (let i = 1; i <= this.state.totalPPTPage; i++) {
            pages.push(`${i}`);
        }
        switch (selectedLinkType) {
            case 'url':
                return (
                    <div className={Style['link-menu-item-wrapper']}>
                        <LinkMenuItem
                            itemName={i18n.t('链接')}
                            itemPlaceholder={i18n.t('请输入网页链接地址')}
                            isWarning={isUrlWarning}
                            inputTextInfo={urlLinkInfo}
                            handleInputChange={this.handleLinkChange}
                            handleBlur={this.handleBlur}
                            ref={this.linkRef}
                        />
                        <div
                            style={{ display: isUrlWarning ? 'block' : 'none' }}
                            className={Style['link-menu-warning']}
                        >{i18n.t('链接格式输入错误')}</div>
                    </div>
                );
            case 'ppt':
                return (
                    <div className={Style['link-menu-ppt-items']}>
                        <Radio.Group
                            value={selectedPPTAction}
                            options={pptActions}
                            itemStyle={{ marginBottom: 8, paddingBottom: 0 }}
                            onChange={this.handleSelectPPTChange}
                        />
                        <div className={Style['link-menu-ppt-select']} ref={this.listRef}>
                            <Select
                                defaultValue={selectedPPTTarget}
                                style={{ width: 81, height: 24 }}
                                listStyle={{ height: listHeight }}
                                onChange={this.handleSelectTargetChange}
                                onVisibleChange={this.handlePageVisibleChange}
                                disabled={selectedPPTAction !== 'ppaction://hlinksldjump'}
                                containerDom={this.listRef?.current || undefined}
                                destroyOnClose={false}
                            >
                                {
                                    pages.map(item => <Select.Option value={item} key={item}>{item}</Select.Option>)
                                }
                            </Select>
                        </div>
                    </div>
                );
            case 'email':
                return (
                    <React.Fragment>
                        <div className={Style['link-menu-item-wrapper']}>
                            <LinkMenuItem
                                itemName={i18n.t('地址')}
                                itemPlaceholder={i18n.t('请输入邮件地址')}
                                isWarning={isEmailWarning}
                                inputTextInfo={emailAddrInfo}
                                handleInputChange={this.handleLinkChange}
                                handleBlur={this.handleBlur}
                                ref={this.addrRef}
                            />
                            <div
                                style={{ display: isEmailWarning ? 'block' : 'none' }}
                                className={Style['link-menu-warning']}
                            >{i18n.t('邮件格式输入错误')}</div>
                        </div>
                        <LinkMenuItem
                            itemName={i18n.t('主题')}
                            itemPlaceholder={i18n.t('选填')}
                            inputTextInfo={emailSubInfo}
                            handleInputChange={this.handleSubjectChange}
                        />
                    </React.Fragment>
                );
            default:
                return null;
        }
    }
}
